import React, { ReactNode, useState, useMemo } from "react"
import { map, get, chunk, clone, set } from "lodash"

import { Labels } from "components/atoms/input/input"
import { BaseTable, UnitChangeTable } from "components/molecules/table"
import { tableColumns } from "config/table_columns"
import { APIResponse } from "redux/apis/types"
import { Pagination } from "components/molecules/pagination"
import { Panel } from "./index"
import { IPODataType } from "components/types/pages/domestic"
import { PAGE_NUM, history } from "config/const"
import { ItemToCreateData, ipoDataCategory } from "components/actions/ipo"
import { SpDetailTable } from "components/molecules/table/spTable"
import { checkIsSp, open_symbol_detail } from "utils/util"
import * as Formatter from "utils/Formatter"
import ClassNames from "classnames"
import store from "redux/store"
import { showSymbol } from "redux/ducks/SymbolDetail"

/************
 *国内株＞IPO
 ***********/

type IpoDetailType = {
  ipoDataList: {
    data: Array<APIResponse.Res>
    setData: Function
    currentPage: number
    changePage: Function
    ipoDataCategory: object
  }
  isPhone: boolean
}

export const IPODetail: React.FC<IpoDetailType> = props => {
  const { ipoDataList, isPhone } = props
  const data = get(ipoDataList.data, "ResultList")
  const total = get(ipoDataList.data, "TotalCount")
  const list = get(ipoDataList.ipoDataCategory, "list[0]")
  const isPublished =
    get(ipoDataList.ipoDataCategory, "id") === get(ipoDataCategory, "[2].id")
  return (
    <div
      className={ClassNames("block-title-table", { published: isPublished })}
    >
      {isPhone ? (
        <SpDetailTable
          headerList={tableColumns.data.ipoDetailSp.header}
          bodyList={tableColumns.data.ipoDetailSp.body}
          data={data}
          onClick={(data: object) =>
            isPublished &&
            store.dispatch(
              showSymbol({
                Symbol: get(data, "Symbol"),
                Exchange: get(data, "ExchangeDivisions[0].Exchange"),
                SecurityType: 1,
              })
            )
          }
        />
      ) : (
        <>
          <BaseTable
            list={list}
            className={ClassNames("table-striped", {
              "table-list-view": isPublished,
            })}
            data={data}
            onClick={(data: object) =>
              isPublished &&
              open_symbol_detail({
                Symbol: get(data, "Symbol"),
                Exchange: get(data, "ExchangeDivisions[0].Exchange"),
                SecurityType: 1,
              })
            }
          />
          <Pagination
            total={total}
            list={data}
            current={ipoDataList.currentPage}
            page={PAGE_NUM.PAGE_10}
            changePage={ipoDataList.changePage}
          />
        </>
      )}
    </div>
  )
}

/****************
 *国内株＞銘柄情報
 ***************/

type DataPanelProps = {
  children?: ReactNode
  label?: Array<any>
  isUnitChangeTable?: boolean
  itemToCreateData: ItemToCreateData
}

export const Data: React.FC<DataPanelProps> = props => {
  const { itemToCreateData, label, isUnitChangeTable } = props
  const data = get(itemToCreateData.data, "ResultList")
  const tableList = get(itemToCreateData.currentCategory, "list")
  const totalCount = get(itemToCreateData.data, "TotalCount")
  const isSp = useMemo(() => {
    return checkIsSp()
  }, [])

  return (
    <>
      {!isSp && (
        <div className="control-row filter-control-row sp">
          <Labels
            className="btn-segmented-control btn-thin liquid-control right-justify"
            labelList={label}
            onChange={(id: number) => {
              if (id === itemToCreateData.activeLabel) return
              itemToCreateData.changeLabel(id)
              itemToCreateData.changePage(0)
              itemToCreateData.setData([])
              itemToCreateData.changeCategory(get(label, `${id}`))
            }}
            checked={itemToCreateData.activeLabel}
          />
        </div>
      )}
      <div className="result-list-block">
        {isSp ? (
          <SpDetailTable
            headerList={tableList[0]}
            bodyList={tableList[1]}
            data={data}
          />
        ) : isUnitChangeTable ? (
          <UnitChangeTable
            className="table-striped unit-change-table"
            list={tableList[0]}
            data={data}
          />
        ) : (
          <BaseTable
            className="table-striped"
            list={tableList[0]}
            data={data}
          />
        )}
        {!isSp && (
          <Pagination
            total={totalCount}
            list={data}
            current={itemToCreateData.currentPage}
            page={PAGE_NUM.PAGE_20}
            changePage={itemToCreateData.changePage}
          />
        )}
      </div>
    </>
  )
}

/****************
 *国内株＞国内サマリー＞新規上場銘柄
 ***************/

type DomesticSummaryIPOType = {
  IpoData: IPODataType
  // onClick?: Function
  reload?: Function
  history?: history
}
export const DomesticSummaryIPO: React.FC<DomesticSummaryIPOType> = props => {
  const [currentPage, setCurrentPage] = useState([0, 0, 0])
  const isSp = useMemo(() => {
    return checkIsSp()
  }, [])
  const _setCurrentPage = (id: number) => {
    return (pageNo: number) => {
      const _currentPage = clone(currentPage)
      set(_currentPage, [id], pageNo)
      setCurrentPage(_currentPage)
    }
  }
  const tableList = useMemo(() => {
    return [
      {
        id: 0,
        table: tableColumns.change.listed.today,
        data: get(props.IpoData, "today", []),
        pagination: get(props.IpoData, ["today", "ResultList"], []),
        title: "本日公開",
        addClass: "not-transition",
        onClick: (data: object) => {},
      },
      {
        id: 1,
        table: tableColumns.change.listed.future,
        data: get(props.IpoData, "future", []),
        pagination: get(props.IpoData, ["future", "ResultList"], []),
        title: "公開予定",
        addClass: "not-transition",
        onClick: (data: object) => {},
      },
      {
        id: 2,
        table: tableColumns.change.listed.old,
        data: get(props.IpoData, "past", []),
        pagination: get(props.IpoData, ["past", "ResultList"], []),
        title: "公開済",
        addClass: "transition",
        onClick: (data: object) => {
          const _symbol = {
            Symbol: get(data, "Symbol"),
            Exchange: get(data, "ExchangeDivisions[0].Exchange"),
            SecurityType: 1,
          }
          !isSp
            ? open_symbol_detail(_symbol)
            : store.dispatch(showSymbol(_symbol))
        },
      },
    ]
  }, [props.IpoData])

  return (
    <Panel
      title={
        <>
          <span className="panel-header-title-items">新規上場銘柄</span>
          <div
            className="btn btn-primary btn-shaped"
            onClick={() =>
              props.history.push({
                pathname: "/domestic/ipo",
              })
            }
          >
            詳細を見る
          </div>
          {/*<span className="panel-header-title-items time">*/}
          {/*  <div className="time-col liquid-item">*/}
          {/*    {Formatter.date(get(props.IpoData, "ServerTime"), "MM/DD HH:mm")}*/}
          {/*  </div>*/}
          {/*</span>*/}
        </>
      }
      className="panel-list ipo-panel"
      // refresh={props.reload}
    >
      {map(tableList, (tableInfo, i: number) => {
        const _currentPage = currentPage[tableInfo.id]
        const dataList: Array<APIResponse.Res> = chunk(
          get(tableInfo.data, "ResultList"),
          PAGE_NUM.PAGE_5
        )[_currentPage]

        return (
          <div className="result-list-block" key={i}>
            <div className="ipo-table-title title-border">
              {tableInfo.title}
            </div>
            <BaseTable
              className="table-striped table-list-view"
              list={tableInfo.table}
              data={dataList}
              onClick={(row: object) => tableInfo.onClick(row)}
              addBodyClass={tableInfo.addClass}
            />
            <Pagination
              list={tableInfo.pagination}
              current={_currentPage}
              page={PAGE_NUM.PAGE_5}
              changePage={_setCurrentPage(tableInfo.id)}
            />
          </div>
        )
      })}
    </Panel>
  )
}
